module.exports = __webpack_public_path__ + "static/img/smartAutomated.982fad82.png";